(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heyde-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('.heyde-tl__wrap');
    var fill = document.querySelector('.heyde-tl__fill');
    if (!wrap || !fill) return;
    var scroller = document.querySelector('.page-wrapper');

    function update() {
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var anchor = vh * 0.55;
      var progress = (anchor - rect.top) / rect.height;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      fill.style.height = (progress * 100) + '%';
    }

    update();
    (scroller || window).addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
